function PrivacyPage() {
  return (
    <div className="compliance-page-route">
      <div className="compliance-page">
        <div className="compliance-shell compliance-shell-narrow">
          <header className="compliance-hero">
            <div className="compliance-eyebrow">Galaxy Access</div>
            <h1 className="compliance-title">Privacy Policy</h1>
            <p className="compliance-copy">
              This Privacy Policy explains how Galaxy Access collects, uses, and protects phone
              numbers and related contact information when communicating with customers by SMS for
              customer care, service-related conversations, account notifications, and operational
              communications.
            </p>
          </header>

          <section className="compliance-card compliance-article">
            <h2>Use of Mobile Information</h2>
            <p>
              Galaxy Access may collect and use mobile phone numbers to send SMS messages related to
              verification codes, account notifications, appointments, order and delivery updates,
              service notifications, and customer support.
            </p>
            <p>
              Customers must separately and voluntarily opt in before receiving SMS messages. SMS
              consent is optional and is not a condition of purchasing any product or receiving any
              service.
            </p>
            <p>
              Message frequency varies based on your interactions with Galaxy Access. Message and
              data rates may apply according to your wireless plan.
            </p>
            <p>
              You may reply STOP at any time to opt out of future SMS messages. You may reply HELP
              for assistance.
            </p>
            <p>
              Galaxy Access does not share, sell, rent, or disclose mobile phone numbers or SMS
              consent data to third parties or affiliates for marketing or promotional purposes.
            </p>
            <p>
              SMS communications are intended for customer care, conversational, account-related, and
              operational use cases. Customers will not receive unsolicited messages.
            </p>
            <p>
              Galaxy Access retains records showing when and how customers consented to receive SMS
              messages.
            </p>
            <p>
              For additional information about the SMS programme, please review our{' '}
              <a href="https://voip.galaxyaccess.us/terms">Terms & Conditions</a>.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}

export default PrivacyPage;
